import React, { createContext, useContext, useRef } from 'react';

interface SectionRef {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface SectionContextType {
  buyerSectionRef: React.RefObject<SectionRef>;
  addressSectionRef: React.RefObject<SectionRef>;
  cashReceiptSectionRef: React.RefObject<SectionRef>;
}

const SectionContext = createContext<SectionContextType | undefined>(undefined);

export function useSectionContext() {
  const context = useContext(SectionContext);
  if (!context) {
    throw new Error('useSectionContext must be used within a SectionRefsProvider');
  }
  return context;
}

export function SectionRefsProvider({ children }: { children: React.ReactNode }) {
  const buyerSectionRef = useRef<SectionRef>({ refs: { current: {} } });
  const addressSectionRef = useRef<SectionRef>({ refs: { current: {} } });
  const cashReceiptSectionRef = useRef<SectionRef>({ refs: { current: {} } });

  return (
    <SectionContext.Provider value={{ buyerSectionRef, addressSectionRef, cashReceiptSectionRef }}>
      {children}
    </SectionContext.Provider>
  );
}
